<template>
  <standard-dialog
    v-model="model"
    :title="$t('stock')"
    icon="mdi-arrow-u-left-top"
    :save-text="$t('save')"
    :disabled="!grocery || !quantity"
    @save="save"
  >
    <v-form ref="form" v-model="valid">
      <autocomplete
        v-model="grocery"
        :loading="loading"
        :items="inventory"
        item-text="name"
        return-object
        :label="$t('warehouse.choose_article')"
        :hide-details="false"
        :hint="$t('warehouse_issued_items_hint')"
      ></autocomplete>
      <text-field
        :label="$t('warehouse.warehouse_status')"
        type="number"
        :value="grocery ? grocery.quantity || 0 : null"
        :suffix="grocery?.measure || ''"
        readonly
      ></text-field>
      <text-field
        v-model="quantity"
        :label="$t('quantity') + $t('for_return')"
        type="number"
        :suffix="grocery ? grocery.measure : ''"
        :max="grocery?.quantity || 0"
        :rules="[rules.required]"
      ></text-field>
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import warehouseService from "@/services/warehouse";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  components: {
    StandardDialog,
  },
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    warehouse: {
      type: [Object, null, undefined],
      required: true,
    },
    groceries: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    grocery: null,
    quantity: null,
    loading: false,
    inventory: [],
    inventoryLoaded: false,
  }),
  methods: {
    async getInventory() {
      this.loading = true;
      try {
        const { data: exitData } = await warehouseService.getWarehouseDocuments({
          document_type: "exit",
        });
        const groceries = exitData.map((document) => document.groceries).flat();
        const groceryIds = [...new Set(groceries.map((grocery) => grocery.id))];
        const allGroceries = groceryIds.map((id) => {
          const sameGroceries = groceries.filter((item) => item.id === id);

          return {
            ...sameGroceries[0],
            quantity: sameGroceries.reduce((sum, item) => sum + (item.quantity || 0), 0),
          };
        });
        this.inventory = allGroceries;
        this.inventoryLoaded = true;
      } catch (error) {
        this.showErrorSnackbar(error, this.$t("error_loading_inventory"));
      } finally {
        this.loading = false;
      }
    },
    save() {
      const grocery = {
        id: this.grocery.grocery_id,
        grocery_id: this.grocery.grocery.id,
        code: this.grocery.grocery.code,
        name: this.grocery.grocery.name,
        measure: this.grocery.measure,
        quantity: Number(this.quantity),
        warehouse_stock: this.grocery.quantity || 0,
        warehouse_id: this.warehouse.id,
        grocery: this.grocery,
        warehouse: this.warehouse,
        transaction_type: "order",
      };
      this.$emit("groceryAdded", grocery);
      this.model = false;
    },
  },
  watch: {
    grocery(newVal) {
      if (!this.grocery) return;
      const grocery = this.groceries.find((item) => item.id === newVal.id);
      if (grocery) {
        this.quantity = grocery.quantity;
      }
    },
    model(newVal) {
      if (newVal) {
        if (!this.inventoryLoaded) {
          this.getInventory();
        }
      } else {
        this.grocery = null;
        this.quantity = null;
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
